/* eslint-disable */

import React from "react";
import { useState } from "react";

import { ReactComponent as IconNoPicture } from "./icon-no-picture.svg";
import { motion } from "framer-motion";

const Image = ({
  id,
  src,
  alt,
  className = "",
  onClick,
  whileHover,
  whileTap,
  width,
  height,
  layoutId,
  animate,
  transition,
  style,
  onLoad = () => {},
  onError = () => {},
}) => {
  const [error, setError] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  if (error) {
    return (
      <div
        src={src}
        className={`flex flex-col items-center justify-center bg-color-raindrop-minor ${className}`}
      >
        <IconNoPicture
          fill={"white"}
          className={"w-1/2 h-1/2"}
          stroke={"white"}
          color={"white"}
          opacity={0.1}
        />
      </div>
    );
  }

  return (
    <div
      id={id}
      className={`flex flex-col aspect-square relative object-cover ${className}`}
    >
      {!hasLoaded && (
        <motion.div
          className={`flex w-full h-full  bg-slate-200 dark:bg-slate-700 absolute top-0 left-0 ${className} `}
          animate={{
            opacity: [0.5, 1],
            transition: {
              duration: 1,
              repeatType: "reverse",
              repeat: Infinity,
            },
          }}
        />
      )}
      <motion.img
        id={id}
        layoutId={layoutId}
        className={`object-cover ${
          hasLoaded ? "opacity-100" : "opacity-0"
        } ${className}`}
        src={src}
        alt={alt}
        draggable={false}
        width={width}
        height={height}
        animate={animate}
        transition={transition}
        whileHover={whileHover}
        whileTap={whileTap}
        onClick={onClick}
        onError={() => {
          onError();
          setError(true);
        }}
        onLoad={() => {
          onLoad();
          setHasLoaded(true);
        }}
      />
    </div>
  );
};

export default Image;
